import AuthPage from './AuthPage';

/**
 * /signup renders the AuthPage directly (URL stays /signup).
 * AuthPage detects window.location.pathname === '/signup' and starts in signup mode.
 */
const SignupAlias = () => <AuthPage />;

export default SignupAlias;
